// Module
var code = "<template><div class=\"dialog-faq dialog-wrap\"><div class=\"wrap-content\"><div class=\"faq-description column column-max\" innerhtml.bind=\"getAdditionalInfo() & async\"></div></div></div></template>";
// Exports
module.exports = code;